import { defineComponent } from 'vue';
import { Button } from '@yellowcard/components-library-vue3';
import moment from 'moment';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import router from '@/router';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { TransactTypes } from '@/types/transact';
export default defineComponent({
    name: 'DepositNotFound',
    components: {
        Button,
    },
    setup() {
        const failedDate = moment().format('DD/MM/YY');
        const transactionsStore = useTransactionsStore();
        const { currentStep } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        const retryDeposit = () => {
            trackEvent(MIXPANEL_EVENTS.BUY.RETRY_DEPOSIT, {
                payment_method: 'Mobile Money',
            });
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        const goHome = () => {
            trackEvent(MIXPANEL_EVENTS.BUY.MY_ACCOUNT, {
                screen: 'Buy EOF Fail Screen',
                partner: partnerId.value,
            });
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        return {
            failedDate,
            retryDeposit,
            goHome,
        };
    },
});
